import * as React from 'react'

/**
 * Renders nothing. Hides the legacy left-rail icon menu (`#statementmenu`)
 * via inline `display: none !important`.
 *
 * Why hide rather than remove: the React UI replaces only the rail's
 * icons. The detail panels behind those icons (`#downloadgraphdata`,
 * `#sharegraphdata`, ...) stay in the DOM because some download buttons
 * still delegate clicks to the legacy `<a>` tags inside them.
 *
 * Also hides any leftover header search inputs that the EJS templates
 * still emit, in case the source-side comment-out wasn't picked up by a
 * cached EJS compile. Their jQuery handlers no-op silently on missing
 * elements, so hiding is sufficient.
 *
 * When the legacy script is retired, delete this component and remove
 * the markup directly from the EJS.
 */
export default function HideLegacyDom() {
    React.useEffect(() => {
        const rail = document.getElementById('statementmenu')
        if (rail) rail.style.setProperty('display', 'none', 'important')

        const sn = document.getElementById('searchnode')
        if (sn) sn.style.setProperty('display', 'none', 'important')
        const sf = document.getElementById('searchform')
        if (sf) sf.style.setProperty('display', 'none', 'important')
    }, [])

    return null
}
